import { render, staticRenderFns } from "./nickname.vue?vue&type=template&id=00a229c3&scoped=true&"
import script from "./nickname.vue?vue&type=script&lang=js&"
export * from "./nickname.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a229c3",
  null
  
)

export default component.exports